export const GO_TABS = {
    HUB: 'hub',
    EXPLORE: 'explore',
    CREATE: 'create',
    ACTIVITY: 'activity',
    ANNOUNCEMENTS: 'announcements',
} as const;

type ValueOf<T> = T[keyof T];
export type GoTab = ValueOf<typeof GO_TABS>;

export interface GoTabProps {
    label: string;
    Icon: (props: { size: number }) => JSX.Element;
    isActive?: boolean;
    href: string;
}
